import { PaginationState } from "../../../../../_dashboard/helpers"
import { useQueryResponse } from "./QueryResponseProvider"
import { initialQueryState } from '../../../../../_dashboard/helpers/crud-helper/models';
import { useIntl } from "react-intl";
export const useQueryResponsePagination = () => {
  const intl = useIntl();
    const defaultPaginationState: PaginationState = {
      links: [],
      ...initialQueryState,
    }
    const {dataResponse} = useQueryResponse()
  
    if (!dataResponse || !dataResponse.payload || !dataResponse.payload?.pagination) {
      return defaultPaginationState
    }
    let pagination = {...dataResponse?.payload?.pagination}
    pagination.links = []
    if (pagination) {
      for (let page = 0; page < pagination?.totalPages; page++) {
        const isActive = page === pagination?.currentPage
        const url = isActive ? null : `?page=${page}` 
        pagination?.links?.push({
          label: `${page + 1}`,
          active: isActive,
          url,
          page,
        })
      }
  
      // Add "prev" button if not on the first page
      if (pagination.currentPage > 0) {
        pagination.links.unshift({
          label: intl.formatMessage({ id: 'PAGINATION.PREVIOUS' }),
          active: false,
          url: `?page=${pagination.currentPage - 1}`,
          page: pagination.currentPage - 1,
        })
      }
      // Add "next" button if not on the last page
      if (pagination.currentPage < pagination.totalPages - 1) {
        pagination.links.push({
          label: intl.formatMessage({ id: 'PAGINATION.NEXT' }),
          active: false,
          url: `?page=${pagination.currentPage + 1}`,
          page: pagination.currentPage + 1,
        })
      }
    }
  
    return pagination
  }
